import { useState, useEffect, useRef } from "react";

export default function LoyaltySearch({ onSelect, onClear, selected }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (query.length < 2) { setResults([]); return; }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(`/api/loyalty/search.php?q=${encodeURIComponent(query)}`);
        const data = await res.json();
        setResults(data);
      } catch { setResults([]); }
      setLoading(false);
    }, 300);
  }, [query]);

  if (selected) {
    return (
      <div style={{
        background: "#3F1907", color: "#fff",
        borderRadius: 10, padding: "10px 14px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        marginBottom: 8
      }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>👤 {selected.name}</div>
          <div style={{ fontSize: 13, opacity: 0.85 }}>
            ⭐ {selected.points} pts · 🏆 {selected.visits} visitas
          </div>
        </div>
        <button onClick={onClear} style={{
          background: "rgba(255,255,255,0.2)", border: "none",
          color: "#fff", borderRadius: 6, padding: "4px 10px", cursor: "pointer"
        }}>✕ Quitar</button>
      </div>
    );
  }

  return (
    <div style={{ position: "relative", marginBottom: 8 }}>
      <input
        value={query}
        onChange={e => setQuery(e.target.value)}
        placeholder="🔍 Buscar cliente (nombre, teléfono o QR)..."
        style={{
          width: "100%", padding: "9px 12px", borderRadius: 8,
          border: "1px solid #ccc", fontSize: 14, boxSizing: "border-box"
        }}
      />
      {loading && (
        <div style={{ fontSize: 12, color: "#888", padding: "4px 12px" }}>Buscando...</div>
      )}
      {results.length > 0 && (
        <div style={{
          position: "absolute", top: "100%", left: 0, right: 0,
          background: "#fff", border: "1px solid #ddd", borderRadius: 8,
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)", zIndex: 100, overflow: "hidden"
        }}>
          {results.map(c => (
            <div
              key={c.id}
              onClick={() => { onSelect(c); setQuery(""); setResults([]); }}
              style={{
                padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f0f0f0",
                display: "flex", justifyContent: "space-between", alignItems: "center"
              }}
              onMouseEnter={e => e.currentTarget.style.background = "#f9f3ef"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}
            >
              <div>
                <div style={{ fontWeight: 600 }}>{c.name}</div>
                <div style={{ fontSize: 12, color: "#888" }}>{c.phone || c.email || c.qr_code}</div>
              </div>
              <div style={{ fontSize: 13, color: "#3F1907", fontWeight: 600 }}>
                ⭐ {c.points} pts
              </div>
            </div>
          ))}
          <div
            onClick={() => { onSelect(null); setQuery(""); setResults([]); }}
            style={{
              padding: "10px 14px", cursor: "pointer",
              color: "#888", fontSize: 13, textAlign: "center",
              borderTop: "1px solid #eee"
            }}
          >
            Continuar como cliente general
          </div>
        </div>
      )}
    </div>
  );
}